import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPortalSqlHDef extends Layout {
    sourceRenlgxsqlh2: DataSource;
    sourceRenlgxsqlh: DataSource;
    textboxLgxshDesc: Textbox;
    textboxLgxshSqlgid: Textbox;
}
